@if (isEpcotEnableed) {
    <button
        ds-button-icon
        msThemedIconButton
        size="small"
        variant="flat"
        kind="tertiary"
        [themeInverse]="themedButtonInverse"
        [class.score-minus-circle-disabled]="isDecrementForbidden"
        [attr.disabled]="isDecrementForbidden"
        (click)="decrement($event)">
        <vn-icon name="theme-minus-circle" size="16" />
    </button>
} @else {
    <button
        class="odd-number-button"
        [class.odd-number-button-disabled]="isDecrementForbidden"
        [attr.disabled]="isDecrementForbidden"
        (click)="decrement($event)">
        -
    </button>
}

<span class="odd-value">{{ participantScore | msTwoDigitConverter: shouldAddPrefix }}</span>

@if (isEpcotEnableed) {
    <button
        ds-button-icon
        msThemedIconButton
        size="small"
        variant="flat"
        kind="tertiary"
        [themeInverse]="themedButtonInverse"
        [class.score-plus-circle-disabled]="isIncrementForbidden"
        [attr.disabled]="isIncrementForbidden"
        (click)="increment($event)">
        <vn-icon name="theme-plus-circle" size="16" />
    </button>
} @else {
    <button
        class="odd-number-button"
        [class.odd-number-button-disabled]="isIncrementForbidden"
        [attr.disabled]="isIncrementForbidden"
        (click)="increment($event)">
        +
    </button>
}
